var Stream = require('stream').Stream;

module.exports = function(o) {
  return !!o && o instanceof Stream;
};



//////////////////
// WEBPACK FOOTER
// ./~/vinyl/lib/isStream.js
// module id = 1869
// module chunks = 0